// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","844":"component---src-pages-privacy-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5a688d7a9cc834cb8bc6","844":"e4fc2f962b80c9fc2988","883":"21601c1cbb0202253a16"}[chunkId] + ".js";
};